import { inject } from '@angular/core';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { environment } from 'environments/environment.prod';
import { forkJoin, of } from 'rxjs';

export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    // NOTE: navigationService.get() is now called by RoutePermissionGuard
    // This prevents duplicate API calls and ensures navigation is loaded before route activation
    return forkJoin([
        messagesService.getAll(),
        notificationsService.getAll(),
        quickChatService.getChats(),
        environment.useShortcuts ? shortcutsService.getAll(): of({ data: [], status: 'Skipped', statusCode: '204' }),
    ]);
};
